export default __webpack_public_path__ + "static/media/project-modal-arrow-right.bb5d47e2.svg";